/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc
 */
import * as References from './ReviewsRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#generateTitle
 */
export const GENERATE_TITLE_QUERY_FIELD_NAME =
  'com_hubspot_reviews_rpc_ReviewsRpc_generateTitle';
export const GENERATE_TITLE_QUERY: RegisteredQuery<
  'result',
  References.GenerateTitleRequestType,
  References.GenerateTitleResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GENERATE_TITLE_QUERY_FIELD_NAME,
  args: ['type', 'entityName', 'answers', 'ratings'],
  fetcher(
    request: References.GenerateTitleRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GenerateTitleResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.generateTitleRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getSummary
 */
export const GET_SUMMARY_QUERY_FIELD_NAME =
  'com_hubspot_reviews_rpc_ReviewsRpc_getSummary';
export const GET_SUMMARY_QUERY: RegisteredQuery<
  'result',
  References.GetSummaryRequestType,
  References.GetSummaryResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SUMMARY_QUERY_FIELD_NAME,
  args: ['entityId', 'type', 'language'],
  fetcher(
    request: References.GetSummaryRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetSummaryResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getSummaryRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getEditability
 */
export const GET_EDITABILITY_QUERY_FIELD_NAME =
  'com_hubspot_reviews_rpc_ReviewsRpc_getEditability';
export const GET_EDITABILITY_QUERY: RegisteredQuery<
  'result',
  References.GetEditabilityRequestType,
  References.GetEditabilityResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_EDITABILITY_QUERY_FIELD_NAME,
  args: ['reviewId', 'legacyReviewId'],
  fetcher(
    request: References.GetEditabilityRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetEditabilityResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getEditabilityRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getThemes
 */
export const GET_THEMES_QUERY_FIELD_NAME =
  'com_hubspot_reviews_rpc_ReviewsRpc_getThemes';
export const GET_THEMES_QUERY: RegisteredQuery<
  'result',
  References.GetThemesRequestType,
  References.GetThemesResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_THEMES_QUERY_FIELD_NAME,
  args: ['entityId', 'type', 'language'],
  fetcher(
    request: References.GetThemesRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetThemesResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getThemesRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#searchReviews
 */
export const SEARCH_REVIEWS_QUERY_FIELD_NAME =
  'com_hubspot_reviews_rpc_ReviewsRpc_searchReviews';
export const SEARCH_REVIEWS_QUERY: RegisteredQuery<
  'result',
  References.SearchReviewsRequestType,
  References.SearchReviewsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: SEARCH_REVIEWS_QUERY_FIELD_NAME,
  args: [
    'search',
    'language',
    'sortFields',
    'entityId',
    'reviewTypes',
    'reviewTypesEnums',
    'overallRating',
    'reviewerPortalId',
    'reviewerUserId',
    'employeeSizes',
    'industries',
    'tagFilters',
    'limit',
    'offset',
  ],
  fetcher(
    request: References.SearchReviewsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SearchReviewsResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.searchReviewsRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#searchReviewsLegacy
 */
export const SEARCH_REVIEWS_LEGACY_QUERY_FIELD_NAME =
  'com_hubspot_reviews_rpc_ReviewsRpc_searchReviewsLegacy';
export const SEARCH_REVIEWS_LEGACY_QUERY: RegisteredQuery<
  'result',
  References.SearchReviewsLegacyRequestType,
  References.SearchReviewsLegacyResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: SEARCH_REVIEWS_LEGACY_QUERY_FIELD_NAME,
  args: [
    'search',
    'language',
    'sortFields',
    'entityId',
    'reviewTypes',
    'reviewTypesEnums',
    'overallRating',
    'reviewerPortalId',
    'reviewerUserId',
    'employeeSizes',
    'industries',
    'tagFilters',
    'limit',
    'offset',
  ],
  fetcher(
    request: References.SearchReviewsLegacyRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SearchReviewsLegacyResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.searchReviewsLegacyRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#checkReviewability
 */
export const CHECK_REVIEWABILITY_QUERY_FIELD_NAME =
  'com_hubspot_reviews_rpc_ReviewsRpc_checkReviewability';
export const CHECK_REVIEWABILITY_QUERY: RegisteredQuery<
  'result',
  References.CheckReviewabilityRequestType,
  References.CheckReviewabilityResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: CHECK_REVIEWABILITY_QUERY_FIELD_NAME,
  args: ['entityId', 'reviewType'],
  fetcher(
    request: References.CheckReviewabilityRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CheckReviewabilityResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.checkReviewabilityRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#checkReviewabilityByAppIds
 */
export const CHECK_REVIEWABILITY_BY_APP_IDS_QUERY_FIELD_NAME =
  'com_hubspot_reviews_rpc_ReviewsRpc_checkReviewabilityByAppIds';
export const CHECK_REVIEWABILITY_BY_APP_IDS_QUERY: RegisteredQuery<
  'result',
  References.CheckReviewabilityByAppIdsRequestType,
  References.CheckReviewabilityByAppIdsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: CHECK_REVIEWABILITY_BY_APP_IDS_QUERY_FIELD_NAME,
  args: ['appIds'],
  fetcher(
    request: References.CheckReviewabilityByAppIdsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CheckReviewabilityByAppIdsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.checkReviewabilityByAppIdsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getOverallStats
 */
export const GET_OVERALL_STATS_QUERY_FIELD_NAME =
  'com_hubspot_reviews_rpc_ReviewsRpc_getOverallStats';
export const GET_OVERALL_STATS_QUERY: RegisteredQuery<
  'result',
  References.GetOverallStatsRequestType,
  References.GetOverallStatsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_OVERALL_STATS_QUERY_FIELD_NAME,
  args: ['entityId', 'reviewType'],
  fetcher(
    request: References.GetOverallStatsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetOverallStatsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getOverallStatsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getOverallStatsBatch
 */
export const GET_OVERALL_STATS_BATCH_QUERY_FIELD_NAME =
  'com_hubspot_reviews_rpc_ReviewsRpc_getOverallStatsBatch';
export const GET_OVERALL_STATS_BATCH_QUERY: RegisteredQuery<
  'result',
  References.GetOverallStatsBatchRequestType,
  References.GetOverallStatsBatchResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_OVERALL_STATS_BATCH_QUERY_FIELD_NAME,
  args: ['entityIds', 'reviewTypeName', 'reviewType', 'createdAfter'],
  fetcher(
    request: References.GetOverallStatsBatchRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetOverallStatsBatchResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getOverallStatsBatchRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getReviewStats
 */
export const GET_REVIEW_STATS_QUERY_FIELD_NAME =
  'com_hubspot_reviews_rpc_ReviewsRpc_getReviewStats';
export const GET_REVIEW_STATS_QUERY: RegisteredQuery<
  'result',
  References.GetReviewStatsRequestType,
  References.GetReviewStatsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_REVIEW_STATS_QUERY_FIELD_NAME,
  args: ['entityId', 'reviewType'],
  fetcher(
    request: References.GetReviewStatsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetReviewStatsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getReviewStatsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getReviewStatsBatch
 */
export const GET_REVIEW_STATS_BATCH_QUERY_FIELD_NAME =
  'com_hubspot_reviews_rpc_ReviewsRpc_getReviewStatsBatch';
export const GET_REVIEW_STATS_BATCH_QUERY: RegisteredQuery<
  'result',
  References.GetReviewStatsBatchRequestType,
  References.GetReviewStatsBatchResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_REVIEW_STATS_BATCH_QUERY_FIELD_NAME,
  args: ['entityIds', 'reviewType'],
  fetcher(
    request: References.GetReviewStatsBatchRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetReviewStatsBatchResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getReviewStatsBatchRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getPrivateFeedback
 */
export const GET_PRIVATE_FEEDBACK_QUERY_FIELD_NAME =
  'com_hubspot_reviews_rpc_ReviewsRpc_getPrivateFeedback';
export const GET_PRIVATE_FEEDBACK_QUERY: RegisteredQuery<
  'result',
  References.GetPrivateFeedbackRequestType,
  References.GetPrivateFeedbackResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_PRIVATE_FEEDBACK_QUERY_FIELD_NAME,
  args: ['entityId', 'reviewType', 'limit', 'offset', 'sort'],
  fetcher(
    request: References.GetPrivateFeedbackRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetPrivateFeedbackResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getPrivateFeedbackRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getReviewRequestEmailTokens
 */
export const GET_REVIEW_REQUEST_EMAIL_TOKENS_QUERY_FIELD_NAME =
  'com_hubspot_reviews_rpc_ReviewsRpc_getReviewRequestEmailTokens';
export const GET_REVIEW_REQUEST_EMAIL_TOKENS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetReviewRequestEmailTokensResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_REVIEW_REQUEST_EMAIL_TOKENS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetReviewRequestEmailTokensResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getReviewRequestEmailTokensRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#previewReviewRequestEmail
 */
export const PREVIEW_REVIEW_REQUEST_EMAIL_QUERY_FIELD_NAME =
  'com_hubspot_reviews_rpc_ReviewsRpc_previewReviewRequestEmail';
export const PREVIEW_REVIEW_REQUEST_EMAIL_QUERY: RegisteredQuery<
  'result',
  References.PreviewReviewRequestEmailRequestType,
  References.PreviewReviewRequestEmailResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: PREVIEW_REVIEW_REQUEST_EMAIL_QUERY_FIELD_NAME,
  args: ['listingId', 'userId', 'content'],
  fetcher(
    request: References.PreviewReviewRequestEmailRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.PreviewReviewRequestEmailResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.previewReviewRequestEmailRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getReviewTags
 */
export const GET_REVIEW_TAGS_QUERY_FIELD_NAME =
  'com_hubspot_reviews_rpc_ReviewsRpc_getReviewTags';
export const GET_REVIEW_TAGS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetReviewTagsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_REVIEW_TAGS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetReviewTagsResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getReviewTagsRpc, {
      timeout: ctx.timeout,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getReviewerDisplayName
 */
export const GET_REVIEWER_DISPLAY_NAME_QUERY_FIELD_NAME =
  'com_hubspot_reviews_rpc_ReviewsRpc_getReviewerDisplayName';
export const GET_REVIEWER_DISPLAY_NAME_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetReviewerDisplayNameResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_REVIEWER_DISPLAY_NAME_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetReviewerDisplayNameResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getReviewerDisplayNameRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getOwnReviewsByAppIds
 */
export const GET_OWN_REVIEWS_BY_APP_IDS_QUERY_FIELD_NAME =
  'com_hubspot_reviews_rpc_ReviewsRpc_getOwnReviewsByAppIds';
export const GET_OWN_REVIEWS_BY_APP_IDS_QUERY: RegisteredQuery<
  'result',
  References.GetOwnReviewsByAppIdsRequestType,
  References.GetOwnReviewsByAppIdsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_OWN_REVIEWS_BY_APP_IDS_QUERY_FIELD_NAME,
  args: ['appIds'],
  fetcher(
    request: References.GetOwnReviewsByAppIdsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetOwnReviewsByAppIdsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getOwnReviewsByAppIdsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
